var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 mb-4"},[_c('Header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }